import React from 'react';
import { connect } from 'react-redux';
import { fetchLogotypeModel } from './LogotypeBlock.action';
import LogotypeBlock from './LogotypeBlock';

class LogotypeBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <LogotypeBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchLogotypeModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.LogotypeReducer.result,
        innerWidth: state.browserSize.innerWidth
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LogotypeBlockContainer);